import { Button } from '@cencosud-cencommerce/paris-uikit';

import { customerSignIn } from '@/modules/shared/infrastructure/mocks/customerSignIn';

export const CustomerSignInButton = () => {
  const handleClick = async () => {
    await customerSignIn();
  };
  return <Button onClick={handleClick}>Entrar como customer</Button>;
};
